import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import SEO from '../components/SEO';

export default function CollectionsPage() {
    const [collections, setCollections] = useState([]);

    useEffect(() => {
        api.get('/collections').then((r) => setCollections(r.data)).catch(() => {});
    }, []);

    return (
        <div className="max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-10 py-14 lg:py-20" data-testid="collections-page">
            <SEO
                title="Collections"
                description="Explore by anfal collections: New Arrivals, Summer Romance, Evening Affair, and more."
                canonical="/collections"
            />
            <div className="text-center mb-12">
                <p className="eyebrow" style={{ color: 'var(--brand-burgundy)' }}>Lookbooks</p>
                <h1 className="font-serif text-5xl md:text-6xl mt-2" style={{ color: 'var(--brand-burgundy)' }}>Collections</h1>
                <hr className="divider-burgundy mt-5 mx-auto" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-7">
                {collections.map((c, i) => (
                    <Link
                        key={c.id}
                        to={`/collections/${c.slug}`}
                        data-testid={`collection-card-${c.slug}`}
                        className="group relative overflow-hidden rounded-2xl aspect-[3/4] block fade-in"
                        style={{ animationDelay: `${i * 80}ms` }}
                    >
                        {c.cover_image && (
                            <img src={c.cover_image} alt={c.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.05]" />
                        )}
                        <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(0,0,0,0.55) 100%)' }} />
                        <div className="absolute inset-x-0 bottom-0 p-6 text-white">
                            <p className="eyebrow text-white/80">Collection</p>
                            <h2 className="font-serif text-3xl md:text-4xl mt-1">{c.name}</h2>
                            {c.description && <p className="text-sm mt-1 text-white/85 max-w-md">{c.description}</p>}
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}
